<section id="hero" class="hero">
    <div class="hero__content">
      <h1>
        {{ 'HERO.TITLE_LINE1' | translate }}<br />
      </h1>
  
      <p [innerHTML]="'HERO.DESCRIPTION' | translate"></p>
  
      <div class="hero__cta-buttons">
        <a href="#contact" class="cta-contact-button">
          <span class="icon">🚀</span>
          <span class="text">{{ 'HERO.CTA' | translate }}</span>
        </a>
        <a href="/Hueseyin-Korkut-CV.pdf" class="cta-contact-button" download>
          <span class="icon">📄</span>
          <span class="text">CV als PDF</span>
        </a>
      </div>
      

    </div>
  </section>
  